import { useState } from "react";

import {
  AppMenu as FoundationAppMenu,
  AppMenuItem,
  Icon,
  useAppMenuContext,
  useResponsive
} from "@introist/react-foundation/v2";
import { LayoutDashboard, Settings } from "lucide-react";
import { useNavigate } from "react-router";
import { SupportDrawer } from "./components/SupportDrawer";
import { useAutomationStudioMenuItems } from "./AutomationStudioMenuItems";
import { useDataStudioMenuItems } from "./DataStudioMenuItems";
import { IWorkspaceSelectorProps } from "@introist/react-foundation/v2/06-views/ProductMenu/WorkspaceSelector";
import { useAIStudioMenuItems } from "./AIStudioMenuItems";

export const AppMenu = ({
  productTitle,
  productKey,
  workspace,
  hasProducts
}: {
  productKey?: string;
  productTitle?: string;
  workspace: IWorkspaceSelectorProps;
  hasProducts?: boolean;
}) => {
  const { collapsed, setCollapsed, toggleMenuCollapsed } = useAppMenuContext();

  const { isMobileLayout } = useResponsive();

  const [supportDrawerOpen, setSupportDrawerOpen] = useState(false);

  const navigate = useNavigate();
  const handleItemClick = (to: string) => (e: React.MouseEvent) => {
    if (e.metaKey || e.ctrlKey) window.open(to, "_blank");
    else navigate(to);
    isMobileLayout && setCollapsed(true);
  };

  const automationStudioItems = useAutomationStudioMenuItems(handleItemClick);
  const dataStudioItems = useDataStudioMenuItems(handleItemClick);
  const aiStudioItems = useAIStudioMenuItems(handleItemClick);

  const getItems = (): AppMenuItem[] => {
    if (productKey === "data-studio") return dataStudioItems;
    if (productKey === "ai-studio") return aiStudioItems;
    if (productKey === "wellbeing") return [
      { title: "Dashboard", icon: <LayoutDashboard size={16} />, onClick: handleItemClick("/wellbeing") }
    ];
    if (productKey === "performance-reviews") return [
      { title: "Dashboard", icon: <LayoutDashboard size={16} />, onClick: handleItemClick("/performance-reviews") },
      { title: "Configuration", icon: <Settings size={16} />, onClick: handleItemClick("/performance-reviews/config") }
    ];

    return automationStudioItems;
  };

  return (
    <>
      <FoundationAppMenu
        collapsed={collapsed}
        product={productTitle}
        user={workspace.user}
        onToggleCollapse={toggleMenuCollapsed}
        onLogout={workspace.onLogout}
        items={getItems()}
        bottomItems={
          !hasProducts
            ? [
                {
                  title: "Help & Support",
                  icon: <Icon name="bulb" />,
                  onClick: () => setSupportDrawerOpen(true)
                }
              ]
            : undefined
        }
        organisation={workspace.organisation}
        workspaces={workspace.workspaces}
        createWorkspace={workspace.createWorkspace}
        switchWorkspace={workspace.switchWorkspace}
      />

      <SupportDrawer open={supportDrawerOpen} onClose={() => setSupportDrawerOpen(false)} />
    </>
  );
};
